import { FLAGS } from '@iheartjane/feature-flags';
import { getSpecialSlug } from '@iheartjane/menu';
import { Typography } from '@iheartjane/reefer';
import type { Nullable } from '@iheartjane/types';

import { BloomLink } from '@jane/bloom/components/bloomLink';
import { useCustomLanguage } from '@jane/bloom/hooks/useCustomLanguage';
import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import type { StoreSpecial } from '@jane/bloom/types/schemas/marketplace/storeSpecials';
import type { ComplianceLanguage } from '@jane/bloom/types/schemas/roots/complianceLanguage';
import { getSpecialType } from '@jane/bloom/utils/specials/getSpecialType';

import styles from './specialCard.module.css';

interface SpecialCardProps {
  complianceLanguage?: Nullable<ComplianceLanguage>;
  special: StoreSpecial;
}

export function SpecialCard({ complianceLanguage, special }: SpecialCardProps) {
  const { photo } = special;
  const specialPhoto = photo ? photo.urls.original : null;

  const customLanguage = useCustomLanguage();
  const { featureFlags } = useRootLoaderData();
  const extendedDealsLabelsEnabled = featureFlags[FLAGS.c1ExtendedDealsLabels];

  return (
    <BloomLink to={`/deals/${special.id}/${getSpecialSlug(special.title)}`}>
      <div
        className={styles['specialCard']}
        key={special.id}
        data-testid="special-card"
      >
        {specialPhoto ? (
          <img
            className={styles['specialCardImg']}
            src={specialPhoto}
            alt={`${special.title} special`}
          />
        ) : (
          <div className={styles['specialCardImgArea']}>
            <Typography color="inherit" variant="header-bold">
              {special.discount_type === 'target_price'
                ? customLanguage.storeComplianceLanguageSettings?.['bundle'] ||
                  'Bundle'
                : special.discount_amount}
            </Typography>
          </div>
        )}
        <div className={styles['specialCardInfo']}>
          <div className={styles['specialBadge']}>
            <Typography color="inherit" variant="body-bold">
              {getSpecialType(
                special.special_type,
                complianceLanguage,
                extendedDealsLabelsEnabled
              )}
            </Typography>
          </div>
          <Typography variant="body-bold" className={styles['specialTitle']}>
            {special.title}
          </Typography>
        </div>
      </div>
    </BloomLink>
  );
}
